import React from 'react';
import PropTypes from 'prop-types';

import './FormButtons.less';

export function FormButtons({
  disabled, onSkip, submitButtonText,
}) {
  return (
    <div className="FormButtons">
      <button className="continue_button" disabled={disabled} type="submit">{submitButtonText}</button>
      {onSkip && <button className="skip_button" disabled={disabled} onClick={onSkip} type="button">Skip for now</button>}
    </div>
  );
}

FormButtons.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onSkip: PropTypes.func,
  submitButtonText: PropTypes.string,
};

FormButtons.defaultProps = {
  onSkip: null,
  submitButtonText: 'Continue',
};

export default FormButtons;
